import React from 'react';

export const useFocusOutsideRef = (callback: () => void, relatedRefs: any[] = [], ref?: any) => {
  const elementRef = ref ?? React.useRef<any>(null);

  React.useEffect(() => {
    if (!elementRef.current) return;
    let container = elementRef.current;

    const handleFocusOutside = (event: any) => {
      if (container && event.target && !container.contains(event.target) && !relatedRefs.some(ref => ref.current && ref.current.contains(event.target))) {
        callback();
      }
    };

    document.addEventListener('focusin', handleFocusOutside);
    return () => {
      document.removeEventListener('focusin', handleFocusOutside);
    };

  }, [elementRef]);

  return elementRef;
};

